export const questionsByCategory = {
  cpa: [
    {
      id: 'structure',
      question: "What's your business structure?",
      type: 'single-select',
      options: [
        { label: 'LLC', value: 'llc' },
        { label: 'S-Corporation', value: 's-corp' },
        { label: 'C-Corporation', value: 'c-corp' },
        { label: 'Sole Proprietorship', value: 'sole-prop' },
        { label: 'Partnership', value: 'partnership' },
      ],
      required: false,
    },
    {
      id: 'revenue',
      question: "What's your annual revenue range?",
      type: 'single-select',
      options: [
        { label: 'Under $100K', value: 'under-100k' },
        { label: '$100K - $500K', value: '100k-500k' },
        { label: '$500K - $2M', value: '500k-2m' },
        { label: '$2M+', value: '2m-plus' },
      ],
      required: false,
    },
    {
      id: 'services',
      question: 'What services do you need?',
      type: 'multi-select',
      options: [
        { label: 'Tax filing & planning', value: 'tax' },
        { label: 'Bookkeeping', value: 'bookkeeping' },
        { label: 'Financial statements', value: 'financial-statements' },
        { label: 'Audit support', value: 'audit' },
      ],
      required: false,
    },
  ],
  
  payroll: [
    {
      id: 'employees',
      question: 'How many employees do you have?',
      type: 'single-select',
      options: [
        { label: '1-10 employees', value: '1-10' },
        { label: '11-50 employees', value: '11-50' },
        { label: '51-200 employees', value: '51-200' },
        { label: '200+ employees', value: '200-plus' },
      ],
      required: false,
    },
    {
      id: 'multistate',
      question: 'Do you have employees in multiple states?',
      type: 'single-select',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
        { label: 'Planning to expand', value: 'planning' },
      ],
      required: false,
    },
    {
      id: 'benefits',
      question: 'Do you need benefits administration?',
      type: 'single-select',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
        { label: 'Maybe / Not sure', value: 'maybe' },
      ],
      required: false,
    },
  ],
  
  banker: [
    {
      id: 'needs',
      question: 'What are you looking for?',
      type: 'multi-select',
      options: [
        { label: 'Business checking account', value: 'checking' },
        { label: 'Line of credit', value: 'loc' },
        { label: 'Equipment financing', value: 'equipment' },
        { label: 'Commercial real estate loan', value: 'cre' },
        { label: 'SBA loan', value: 'sba' },
      ],
      required: false,
    },
    {
      id: 'revenue',
      question: "What's your annual revenue range?",
      type: 'single-select',
      options: [
        { label: 'Under $100K', value: 'under-100k' },
        { label: '$100K - $500K', value: '100k-500k' },
        { label: '$500K - $2M', value: '500k-2m' },
        { label: '$2M+', value: '2m-plus' },
      ],
      required: false,
    },
    {
      id: 'age',
      question: 'How long has your business been operating?',
      type: 'single-select',
      options: [
        { label: 'Less than 1 year', value: 'under-1' },
        { label: '1-3 years', value: '1-3' },
        { label: '3-5 years', value: '3-5' },
        { label: '5+ years', value: '5-plus' },
      ],
      required: false,
    },
  ],
  
  hr: [
    {
      id: 'employees',
      question: 'How many employees do you have?',
      type: 'single-select',
      options: [
        { label: '1-10 employees', value: '1-10' },
        { label: '11-50 employees', value: '11-50' },
        { label: '51-200 employees', value: '51-200' },
        { label: '200+ employees', value: '200-plus' },
      ],
      required: false,
    },
    {
      id: 'needs',
      question: 'What do you need help with?',
      type: 'multi-select',
      options: [
        { label: 'HR compliance', value: 'compliance' },
        { label: 'Recruiting & hiring', value: 'recruiting' },
        { label: 'Employee handbook', value: 'handbook' },
        { label: 'Training & development', value: 'training' },
        { label: 'Full-service HR', value: 'full-service' },
      ],
      required: false,
    },
    {
      id: 'industry',
      question: 'What industry are you in?',
      type: 'single-select',
      options: [
        { label: 'Healthcare', value: 'healthcare' },
        { label: 'Technology', value: 'tech' },
        { label: 'Retail', value: 'retail' },
        { label: 'Manufacturing', value: 'manufacturing' },
        { label: 'Professional Services', value: 'professional' },
        { label: 'Other', value: 'other' },
      ],
      required: false,
    },
  ],
  
  insurance: [
    {
      id: 'coverage',
      question: 'What coverage do you need?',
      type: 'multi-select',
      options: [
        { label: 'General liability', value: 'general-liability' },
        { label: 'Workers compensation', value: 'workers-comp' },
        { label: 'Professional liability (E&O)', value: 'professional' },
        { label: 'Cyber insurance', value: 'cyber' },
        { label: 'Commercial property', value: 'property' },
        { label: 'Business health insurance', value: 'health' },
      ],
      required: false,
    },
    {
      id: 'industry',
      question: 'What industry are you in?',
      type: 'single-select',
      options: [
        { label: 'Healthcare', value: 'healthcare' },
        { label: 'Technology', value: 'tech' },
        { label: 'Retail', value: 'retail' },
        { label: 'Manufacturing', value: 'manufacturing' },
        { label: 'Professional Services', value: 'professional' },
        { label: 'Construction', value: 'construction' },
        { label: 'Other', value: 'other' },
      ],
      required: false,
    },
    {
      id: 'employees',
      question: 'How many employees do you have?',
      type: 'single-select',
      options: [
        { label: '1-10 employees', value: '1-10' },
        { label: '11-50 employees', value: '11-50' },
        { label: '51-200 employees', value: '51-200' },
        { label: '200+ employees', value: '200-plus' },
      ],
      required: false,
    },
  ],
  
  retirement: [
    {
      id: 'current-plan',
      question: 'Do you currently offer a retirement plan?',
      type: 'single-select',
      options: [
        { label: 'Yes, we have a 401(k)', value: 'yes-401k' },
        { label: 'Yes, other type', value: 'yes-other' },
        { label: 'No, but considering', value: 'considering' },
        { label: 'No', value: 'no' },
      ],
      required: false,
    },
    {
      id: 'employees',
      question: 'How many employees do you have?',
      type: 'single-select',
      options: [
        { label: '1-10 employees', value: '1-10' },
        { label: '11-50 employees', value: '11-50' },
        { label: '51-200 employees', value: '51-200' },
        { label: '200+ employees', value: '200-plus' },
      ],
      required: false,
    },
    {
      id: 'priority',
      question: "What's your main priority?",
      type: 'single-select',
      options: [
        { label: 'Set up a new plan', value: 'setup' },
        { label: 'Optimize existing plan', value: 'optimize' },
        { label: 'Succession planning', value: 'succession' },
        { label: 'Tax strategies', value: 'tax' },
      ],
      required: false,
    },
  ],
};

export const questionToProfileMapping = {
  'cpa.structure': {
    profileField: 'business_structures_served',
    matchType: 'array-contains',
  },
  'cpa.revenue': {
    profileField: 'revenue_ranges_served',
    matchType: 'array-contains',
  },
  'cpa.services': {
    profileField: 'cpa_services',
    matchType: 'array-overlap',
  },
  'payroll.employees': {
    profileField: 'employee_ranges_served',
    matchType: 'array-contains',
  },
  'payroll.multistate': {
    profileField: 'multi_state_experience',
    matchType: 'boolean-match',
  },
  'payroll.benefits': {
    profileField: 'benefits_administration',
    matchType: 'boolean-match',
  },
  'banker.needs': {
    profileField: 'banking_services',
    matchType: 'array-overlap',
  },
  'banker.revenue': {
    profileField: 'revenue_ranges_served',
    matchType: 'array-contains',
  },
  'banker.age': {
    profileField: 'business_age_served',
    matchType: 'array-contains',
  },
  'hr.employees': {
    profileField: 'employee_ranges_served',
    matchType: 'array-contains',
  },
  'hr.needs': {
    profileField: 'hr_services',
    matchType: 'array-overlap',
  },
  'hr.industry': {
    profileField: 'industries_served',
    matchType: 'array-contains',
  },
  'insurance.coverage': {
    profileField: 'insurance_types',
    matchType: 'array-overlap',
  },
  'insurance.industry': {
    profileField: 'industries_served',
    matchType: 'array-contains',
  },
  'insurance.employees': {
    profileField: 'employee_ranges_served',
    matchType: 'array-contains',
  },
  'retirement.current-plan': {
    profileField: 'existing_plan_experience',
    matchType: 'array-contains',
  },
  'retirement.employees': {
    profileField: 'employee_ranges_served',
    matchType: 'array-contains',
  },
  'retirement.priority': {
    profileField: 'retirement_services',
    matchType: 'array-contains',
  },
};

export default questionsByCategory;
